import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Choix } from 'src/app/utils/interfaces/new/Choix';
import { CreateElementListeDeTravail } from 'src/app/utils/interfaces/new/CreateElementListeDeTravail';
import { ElementListeDeTravail } from 'src/app/utils/interfaces/new/ElementListeDeTravail';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Liste } from 'src/app/utils/interfaces/new/Liste';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ListeDeTravailService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };
  private uriListe = environment.basePath + "/medical/liste-de-travail";

  constructor(
    private http: HttpClient
  ) { }

  public async createListe(elem: CreateElementListeDeTravail): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
        try {
          await this.http.post(this.uriListe, elem, this.httpOptions).toPromise();
          resolve();
        } catch (e) {
            reject(e);
        }
    });
  }

  public async getListe(): Promise<Array<ElementListeDeTravail>> {
    return new Promise<Array<ElementListeDeTravail>>(async (resolve, reject) => {
        try {
          const result = await this.http.get<Array<ElementListeDeTravail>>(this.uriListe, this.httpOptions).toPromise();
          resolve(result.body);
        } catch (e) {
            reject(e);
        }
    });
  }

  public async deleteElemFromListe(elemId: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
        try {
          await this.http.delete<void>(`${this.uriListe}/${elemId}`, this.httpOptions).toPromise();
          resolve();
        } catch (e) {
            reject(e);
        }
    });
  }
}
